import { render, staticRenderFns } from "./EcommerceStatistics.vue?vue&type=template&id=084ccc9f&scoped=true&"
import script from "./EcommerceStatistics.vue?vue&type=script&lang=js&"
export * from "./EcommerceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceStatistics.vue?vue&type=style&index=0&id=084ccc9f&lang=scss&scoped=true&"
import style1 from "./EcommerceStatistics.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ccc9f",
  null
  
)

export default component.exports